var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgJobs = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5C12.9602 2.5 13.3333 2.8731 13.3333 3.33333V5H17.5C17.9602 5 18.3333 5.3731 18.3333 5.83333V16.6667C18.3333 17.1269 17.9602 17.5 17.5 17.5H2.49996C2.03973 17.5 1.66663 17.1269 1.66663 16.6667V5.83333C1.66663 5.3731 2.03973 5 2.49996 5H6.66663V3.33333C6.66663 2.8731 7.03973 2.5 7.49996 2.5H12.5ZM13.3333 6.66667H6.66663V15.8333H13.3333V6.66667ZM3.33329 6.66667V15.8333H4.99996V6.66667H3.33329ZM11.6666 4.16667H8.33329V5H11.6666V4.16667ZM15 6.66667V15.8333H16.6666V6.66667H15Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJobs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/jobs.d49c83d9.svg";
export { ForwardRef as ReactComponent };